import axios from "axios";

const BASE_URL = "https://covid19.mathdro.id/api/countries/india";

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default API;
